var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyRoutine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 470,
    height: 514,
    fill: "none",
    viewBox: "0 0 470 514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M381.888 69.476c.322.144.688.193 1.059.122.94-.183 1.894-.39 2.836-.613a1.77 1.77 0 1 0-.817-3.443c-.895.213-1.801.408-2.694.582a1.768 1.768 0 0 0-.384 3.352",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M409.922 115.548a48 48 0 0 1-5.036-2.712 1.094 1.094 0 0 1-.353-1.505 1.1 1.1 0 0 1 1.505-.354 45 45 0 0 0 4.803 2.588 1.092 1.092 0 1 1-.919 1.983m4.628.712a1.09 1.09 0 0 1 1.376-.702 46 46 0 0 0 5.286 1.37 1.093 1.093 0 0 1-.421 2.145 48 48 0 0 1-5.539-1.436 1.093 1.093 0 0 1-.702-1.377m-14.337-6.732a47 47 0 0 1-4.232-3.851 1.092 1.092 0 1 1 1.566-1.525 45 45 0 0 0 4.037 3.674 1.093 1.093 0 0 1-1.371 1.702m25.242 9.132a1.093 1.093 0 0 1 1.167-1.013c1.811.128 3.647.147 5.459.054a1.094 1.094 0 0 1 .112 2.182c-1.9.098-3.827.079-5.725-.056a1.095 1.095 0 0 1-1.013-1.167m-33.205-17.317a48 48 0 0 1-3.182-4.755 1.093 1.093 0 0 1 1.887-1.104 45 45 0 0 0 3.035 4.535 1.093 1.093 0 0 1-1.74 1.324m-5.769-9.858a48 48 0 0 1-1.952-5.38 1.092 1.092 0 1 1 2.095-.62 46 46 0 0 0 1.864 5.132 1.094 1.094 0 0 1-2.007.868m-3.242-10.957a47 47 0 0 1-.605-5.693 1.093 1.093 0 0 1 2.184-.098c.08 1.81.274 3.636.577 5.428a1.093 1.093 0 0 1-2.156.363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M437.296 119.155c.193.087.412.118.635.079a48 48 0 0 0 2.736-.565 1.093 1.093 0 0 0-.505-2.127c-.853.203-1.731.384-2.61.539a1.093 1.093 0 0 0-.256 2.074"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M425.475 79.365a8.2 8.2 0 0 1-3.631-5.182 8.2 8.2 0 0 1 1.097-6.23c2.448-3.844 7.559-4.977 11.413-2.533 3.844 2.45 4.98 7.568 2.532 11.411a8.21 8.21 0 0 1-5.181 3.63 8.2 8.2 0 0 1-6.23-1.096m-.69-10.239a6.04 6.04 0 0 0-.808 4.584 6.04 6.04 0 0 0 2.671 3.811 6.05 6.05 0 0 0 4.584.807 6.04 6.04 0 0 0 3.81-2.67 6.087 6.087 0 0 0-2.649-8.818 6.09 6.09 0 0 0-7.608 2.286",
    opacity: 0.56
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M421.427 91.018q.947.423 1.952.757a20.7 20.7 0 0 0 4.094.91l.188.02a1.092 1.092 0 1 0 .234-2.172 18.5 18.5 0 0 1-3.828-.833h-.001l-.204-.069a18.2 18.2 0 0 1-7.548-4.921 18.5 18.5 0 0 1-2.831-4.066l-.018-.037q-.03-.055-.057-.112a18.28 18.28 0 0 1-1.027-14.045q.3-.906.685-1.765a18.26 18.26 0 0 1 8.521-8.893 18.28 18.28 0 0 1 14.044-1.026 18.3 18.3 0 0 1 10.658 9.205 18.28 18.28 0 0 1 1.027 14.045 18.34 18.34 0 0 1-5.444 8.15 1.09 1.09 0 0 0-.115 1.541c.395.456 1.083.509 1.542.114a20.53 20.53 0 0 0 6.092-9.117 20.45 20.45 0 0 0-1.149-15.715c-2.469-4.912-6.7-8.572-11.923-10.298a20.45 20.45 0 0 0-15.714 1.15c-4.277 2.148-7.603 5.636-9.532 9.947q-.43.961-.767 1.975c-3.345 10.106 1.605 20.998 11.121 25.255",
    opacity: 0.56
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9dcac",
    d: "M458.244 455.766c-8.461 8.908-16.465 14.653-22.79 19.192-74.343 53.351-162.311 37.799-181.006 34.002-27.608-5.609-80.972-16.449-119.554-61.829-58.371-68.655-49.282-176.819-4.005-248.22 8.281-13.061 52.028-85.549 140.943-97.174 53.811-7.035 116.536 7.154 161.961 45.217 95.349 79.899 88.561 241.307 24.451 308.812"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#492a19",
    d: "M261.074 35.154a6.57 6.57 0 0 1 5.065-1.737C286.035 35.2 323.156 25.65 347.418.915c1.684-1.717 4.755-.747 6.686.691 26.981 20.094 71.706 24.255 87.233 25.106a6.54 6.54 0 0 1 6.149 5.847c14.119 135.883-74.671 185.123-93.086 193.814a6.59 6.59 0 0 1-6.274-.361c-91.781-56.964-87.855-131.045-89.124-185.935a6.53 6.53 0 0 1 2.072-4.923"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9dcac",
    d: "M378 65.058 399.439 108 427 47l-28.628 31.57z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M122.11 401.953c-.003-.193.01-.389.059-.587 2.928-11.608 14.9-17.558 14.9-17.558l5.759.451c3.311 10.231 5.446 15.226 4.914 18.021-.015.078-.038.153-.059.228-4.75.425-14.528.702-25.573-.555"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M147.682 402.509c-.256.933-.945 1.66-1.827 1.845-6.758 1.421-17.498.278-22.007-.312-.995-.13-1.722-1.05-1.739-2.089 11.046 1.257 20.823.98 25.573.556"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m132.328 374.846 2.521 12.138c.185.889.868 1.556 1.697 1.633 1.013.095 2.455.151 3.906-.062 1.3-.191 2.206-1.513 1.975-2.932l-1.752-10.777z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M196.614 402.408c-6.15-.172-9.331-.897-10.976-1.569-.004.612 0 1.234.02 1.879.021.688.531 1.239 1.159 1.235l33.768-.218c1.078-.007 1.708-1.257 1.241-2.245-4.428.366-15.705 1.184-25.212.918"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M221.824 401.49c-.04-.086-.075-.174-.133-.255-2.983-4.167-10.578-12.465-25.587-16.064l-7.201-.227s-3.206 5.573-3.266 15.895c1.644.672 4.825 1.397 10.976 1.569 9.507.266 20.784-.552 25.211-.918"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M187.566 374.032c.08.537 1.067 8.694 1.449 11.857.091.751.636 1.333 1.322 1.415 1.226.146 3.21.279 4.946-.076.936-.192 1.614-1.092 1.614-2.138v-12.804z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0d846",
    d: "M137.139 215.461s-11.522 102.416-5.121 166.426c0 0 7.681 0 11.522-1.28 0 0 11.973-100.136 15.846-128.791.146-1.08 1.688-1.129 1.9-.06 4.779 24.107 23.549 118.643 25.781 127.571 0 0 6.401 2.56 11.522 0 0 0-10.242-136.982-17.923-161.306z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#29493c",
    d: "M114.095 96.403s48.648-7.682 87.054 2.56l-2.56 39.686s-10.242 55.049-17.923 79.373c0 0-29.445 5.121-43.527-2.561 0 0-11.522-69.13-17.923-79.372 0 0-6.401-26.885-5.121-39.686"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m147.889 61.421-4.846 32.774s13.539 6.219 23.02-.267l-2.041-23.13z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M168.754 40.08c.153.278 3.074 16.804 4.872 27.034.743 4.226-2.364 8.152-6.648 8.406l-3.923.232c-7.208.427-13.556-4.705-14.648-11.842l-2.837-18.531s19.479-12.02 23.184-5.298"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M141.342 45.425c-1.504-1.87-2.816-4.895.387-8.075 3.243-3.22 6.922-2.417 9.255-1.337 1.033.477 2.306.266 3.041-.603.327-.386.812-.649 1.531-.568 1.357.152 2.568-.744 2.729-2.1.276-2.323 1.514-5.06 5.623-5.853 7.536-1.457 11.296 6.085 11.162 11.386-.135 5.301-8.395 6.416-13.082 5.536-3.443-.646-6.419 2.379-7.757 4.03a2.5 2.5 0 0 0-.492 2.137l1.191 5.12c-.825 1.593-1.635 3.218-2.794 4.577-.834.978-1.75 1.518-2.72 1.746-1.405-2.615-5.335-3.059-7.161-3.117a2.5 2.5 0 0 1-1.811-.858c-1.378-1.58-3.535-5.105.594-8.567 1.026-.861 1.143-2.41.304-3.454"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M150.775 66.904s-.162-9.247-3.905-10.116-7.78 1.838-4.58 7.374c3.982 6.887 8.485 2.742 8.485 2.742"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#29493c",
    d: "M114.095 96.403S38.563 178.335 127.537 209.7v-6.401s-33.285-28.164-7.681-66.57c0 0-3.201-36.486-5.761-40.327"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M128.178 203.939s11.522-7.681 16.643-5.12 5.121 6.401 5.121 6.401-2.561 5.12-6.401 3.84c-3.841-1.28-12.802 1.28-16.643 0 0 0-1.28-5.121 1.28-5.121"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#29493c",
    d: "M201.148 98.963s78.732 79.372-10.242 110.737v-6.401s33.286-28.164 7.682-66.57c0 0-2.561-31.365 2.56-37.766"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M190.267 203.939s-11.522-7.681-16.642-5.12c-5.121 2.56-5.121 6.401-5.121 6.401s2.56 5.12 6.401 3.84 12.802 1.28 16.642 0c0 0 1.28-5.121-1.28-5.121"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.059 45.272s-8.023 3.902-9.498 8.385c-1.183 3.596-10.054 4.06-10.93 11.134-.453 3.652-3.155 6.577-6.793 7.134-9.06 1.39-23.022 6.094-25.256 21.824-1.705 12.006 4.416 16.559 10.84 18.135 4.717 1.157 7.852 5.746 6.898 10.509-.915 4.569.45 9.85 8.365 14.026 17.736 9.359 35.448-22.171 35.448-22.171l3.63-55.055z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m20.155 390.483-1.148 9.436a3.9 3.9 0 0 1-3.419 3.41c-3.025.345-7.879.699-12.628.197-2.084-.22-3.437-2.331-2.802-4.329 1.157-3.642 3.275-9.11 6.329-12.327h10.467a3.224 3.224 0 0 1 3.2 3.613"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m102.135 279.955 1.766 10.392s-5.916 59.924-6.968 83.894a18.8 18.8 0 0 0 2.78 10.675l10.286 16.705-26.144-15.427-.52-3.191 4.28-5.884-5.606-67.131a20.6 20.6 0 0 1 2.344-11.392l5.408-10.159z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M111.722 404.041h-8.344a5.02 5.02 0 0 1-3.987-1.954c-2.6-3.38-7.99-9.974-10.566-10.146-3.469-.231-3.025 12.1-3.025 12.1h-1.944l-2.463-15.323a9.07 9.07 0 0 1 4.76-9.482s.793 5.864 5.092 8.458c4.3 2.594 17.496 11.883 17.496 11.883s1.617-.231 3.391.09c2.633.476 2.265 4.374-.41 4.374"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M66.323 284.89s-34.658 65.743-40.168 80.753-7.439 27.532-7.513 28.718c-.115 1.853-2.42 3.63-8.772 3.63-3.278 0-4.884-1.314-5.67-2.586-.67-1.085-.705-2.443-.14-3.587 2.004-4.057 8.367-17.023 10.723-22.904 2.813-7.022 8.865-38.841 12.184-49.905s7.07-23.064 21.522-34.119c0 0 9.921-9.717 17.834 0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0d846",
    d: "M88.22 177.167c8.94-37.883-13.708-59.309-13.708-59.309 14.29-13.718 40.328-19.96 40.328-19.96s24.845 18.165 21.897 32.382c-1.727 8.333-17.464 49.912-17.464 49.912s-14.551 6.887-31.053-3.025"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#598070",
    d: "M68.397 195.922c3.638-10.961 19.822-18.755 19.822-18.755 16.502 9.912 31.054 3.025 31.054 3.025s3.263 12.474 1.011 24.065c-2.253 11.592-16.384 86.09-16.384 86.09-22.265 4.511-56.51-4.539-56.51-4.539 14.183-25.18 17.369-78.925 21.007-89.886"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "m98.597 72.864-7.269 32.649c-.696 2.876 1.926 2.405 4.833 1.857 4.762-.898 10.898-2.746 12.95-6.451.209-.377.313-.804.372-1.23l3.123-22.64a4.07 4.07 0 0 0-2.381-4.275l-6.026-2.672a4.067 4.067 0 0 0-5.602 2.762"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M74.51 117.858s-50.731 36.295-6.488 74.434c0 0 1.687 1.909 5.006 2.901 1.675.501 6.632 4.25 9.144 6.206a1.72 1.72 0 0 0 2.519-.453c.425-.68.475-1.53.132-2.255l-6.28-13.281a4.844 4.844 0 0 0-6.292-.272 2.39 2.39 0 0 1-3.624-.821c-3.42-6.966-9.879-27.453 16.554-50.603.994-.87 1.245-2.309.635-3.481-1.857-3.567-6.104-10.652-11.306-12.375"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M112.518 43.101s7.738 5.238 11.063 18.578-2.078 18.124-7.617 17.831-13.57-2.006-20.529-11.576 6.943-31.233 17.083-24.833"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M102.453 62.554s-2.836-19.115 13.034-16.191l3.209 3.34s7.768-8.747-.828-15.36-20.525-4.92-27.125 7.12C84.143 53.5 81.748 61.96 87.28 69.44c5.531 7.48 9.692 1.065 9.692 1.065s-2.536-6.475-.431-9.253 4.82 1.615 4.82 1.615z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M100.283 64.19s-1.4-9.834-6.422-7.022 1.81 9.186 4.55 11.356z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "m327.933 380.508 21.381.745a2.477 2.477 0 0 0 2.56-2.593l-1.004-21.091a2.477 2.477 0 0 0-2.474-2.359H328.02a2.477 2.477 0 0 0-2.477 2.477v20.346a2.477 2.477 0 0 0 2.39 2.475"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M394.471 339.082s-21.359 22.231-34.872 0l-3.923 6.102s15.692 32.257 49.692 3.924z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#29493c",
    d: "M404.596 324.714a28.1 28.1 0 0 1 8.533-3.97c1.146-.312 7.335 1.487 11.16 1.399 5.251-.121 10.597-2.51 14.925-1.432 4.3 1.072 7.819 2.471 9.851 3.916 6.082 4.326 9.653 12.392 11.829 20.382-4.121 4.229-9.306 6.109-9.306 6.109l-.958 38.835-23.467 7.104-25.708-8.513.939-37.952s-10.8-9.228-11.411-10.638 6.27-10.191 13.613-15.24"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M473.596 395.682c-5.763-1.323-19.083-.612-19.083-.612l-.542 1.467-.897 7.293s12.685 2.286 18.937 2.281a5.9 5.9 0 0 0 1.755-.263c.19-.171.377-.348.553-.54 2.652-2.898 1.886-7.153-.723-9.626"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m450.685 394.66 2.256.096c1.211.051 2.353.642 3.168 1.638s1.234 2.314 1.163 3.657c-.057 1.07-.496 2.071-1.221 2.782-.724.71-1.674 1.071-2.639 1.002l-3.451-.245z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M374.849 394.98c5.794-1.145 19.091-.025 19.091-.025l.505 1.483.715 7.317s-12.737 1.896-18.987 1.699a5.9 5.9 0 0 1-1.747-.316 8 8 0 0 1-.54-.558c-2.579-2.977-1.707-7.208.963-9.6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M374.274 395.107q.273-.067.575-.127c-2.671 2.392-3.543 6.623-.963 9.6.171.198.353.381.539.558-4.652-1.603-5.028-8.817-.151-10.031"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "m397.775 394.662-2.257.026c-1.212.015-2.369.57-3.208 1.541s-1.291 2.275-1.253 3.619c.03 1.072.444 2.086 1.151 2.819.706.732 1.647 1.122 2.613 1.083l3.456-.14z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0d846",
    d: "M475.206 372.821c-2.613-6.015-9.005-6.992-14.446-4.179-.095.124-34.55 17.783-64.936 25.522.87 2.789 1.317 5.756 1.415 8.673q.026.975-.031 1.923c23.301-1.197 48.59-8.968 70.321-15.797 6.738-2.173 10.574-9.475 7.677-16.142"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0d846",
    d: "M450.853 403.294q-.136-5.043 1.961-9.389c.04-.133.088-.26.13-.391a281 281 0 0 1-6.921-2.265c-21.577-7.384-38.038-14.84-53.747-23.423-6.104-3.334-13.043-1.099-14.996 6.122-1.745 6.447 2.086 11.95 7.898 13.885 17.39 5.787 8.336 4.179 14.015 6.007 15.253 4.717 34.233 9.013 51.696 10.186-.012-.244-.028-.489-.036-.732"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M413.129 320.744s2.32 10.056 13.587 9.848c11.475-.209 12.498-9.881 12.498-9.881l-7.496-1.604-.626-8.352-11.276.835-.209 7.935z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M405.269 299.334s-4.609-4.737-1.145-8.502c0 0-3.411-4.307-.035-8.687 0 0 2.971-16.773 19.742-9.089 0 0 11.305-6.151 18.831 7.71 0 0 4.588 1.331 4.084 7.228 0 0 5.46 20.285-14.595 17.39z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    fillRule: "evenodd",
    d: "M408.449 285.32s-13.393 24.88 3.157 31.275 23.159-11.102 23.159-11.102 6.142-8.216 3.055-13.553-25.744-10.214-29.371-6.62",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    fillRule: "evenodd",
    d: "M404.924 297.28s.68-3.117-2.083-3.308.811 7.407.811 7.407z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M435.875 301.378s-16.777-3.066-16.602-12.768c0 0-2.76.633-4.033-2.551 0 0-7.016 8.123-9.732 3.407 0 0-.173-12.506 10.004-9.733s19.524 5.72 22.473 8.237 5.969 9.13-2.11 13.408",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    fillRule: "evenodd",
    d: "m432.93 307.978 1.869-8.24s5.216-3.245 5.028 1.133c-.187 4.378-4.864 7.374-6.897 7.107",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M460.357 345.137s8.652 34.92-17.938 44.945c-5.281-.701-8.282-3.051-8.282-3.051s17.596-12.122 16.422-35.976c3.055-2.514 9.798-5.918 9.798-5.918"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M441.111 392.262s-8.282-1.744-11.77-2.18-8.177-1.265-6.05-6.299 5.179-4.162 9.102-1.983c1.803 1.002 11.333 7.41 8.718 10.462"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "m337.809 365.315 19.566.682a2.266 2.266 0 0 0 2.343-2.373l-.919-19.301a2.267 2.267 0 0 0-2.264-2.159h-18.647a2.267 2.267 0 0 0-2.267 2.266v18.62c0 1.221.967 2.222 2.188 2.265"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M343.057 345.125c.364-1.763 1.558-7.943 4.736-9.17 6.576-2.54 12.021 3.527 12.021 3.527l1.093 4.938c-.167-.283-.453-.522-.823-.724-.844 3.243-3.505 6.383-4.844 5.847-2.179-.871-1.743-.872.436-4.359l.018-.028c.619-1.007-.185-2.307-1.364-2.231-2.846.185-5.631.975-6.173 2.2-1.093 2.469-5.465 1.764-5.1 0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "m343.625 405.354 21.38.745a2.476 2.476 0 0 0 2.56-2.593l-1.004-21.091a2.477 2.477 0 0 0-2.474-2.359h-20.376a2.477 2.477 0 0 0-2.477 2.477v20.346a2.476 2.476 0 0 0 2.391 2.475"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "m316.292 405.465 21.387.523a2.476 2.476 0 0 0 2.533-2.619l-1.223-21.079a2.477 2.477 0 0 0-2.499-2.333l-20.375.211a2.48 2.48 0 0 0-2.451 2.503l.212 20.344a2.475 2.475 0 0 0 2.416 2.45"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    fillRule: "evenodd",
    d: "M294.103 387.865s-10.594-5.509-38.561 1.695L253 397.187l17.797 2.966 25.425-.423z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    fillRule: "evenodd",
    d: "m255.249 397.563.29-8.003s-2.118-2.966-4.237-2.542c-2.119.423-14.407 8.474-17.374 9.746-2.966 1.271 4.505 4.564 21.321.799",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    fillRule: "evenodd",
    d: "M287.744 394.221s-10.594-5.508-38.561 1.695l-2.542 7.628 17.797 2.966 25.424-.424z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    fillRule: "evenodd",
    d: "m248.894 403.919.29-8.003s-2.119-2.966-4.238-2.542c-2.118.423-14.407 8.475-17.373 9.746s4.505 4.564 21.321.799",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#29493c",
    fillRule: "evenodd",
    d: "m302.792 352.516 9.022 36.96a17.33 17.33 0 0 1-2.319 13.571 7.63 7.63 0 0 1-6.393 3.463h-29.765l-3.964-18.231a49.6 49.6 0 0 1 .207-21.968l3.747-15.794z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    fillRule: "evenodd",
    d: "M308.085 324.727s14.735 18.114 12.712 29.238c-2.542 13.984-19.492 2.967-19.492 2.967l1.616-5.147s7.706 6.842 8.977.909c1.272-5.932-9.322-15.254-9.322-15.254z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M205.791 285.788c6.877-11.272 18.602-17.419 29.576-16.653 3.301.231 6.598-.657 9.419-2.386 5.319-3.259 12.061-3.57 17.558-.217l.044.027c2.507 1.541 5.594 1.86 8.247.587 7.839-3.761 24.987-1.583 32.365 2.918 12.27 7.486 13.79 22.91 5.368 36.714s-31.738 18.525-44.008 11.039a23.3 23.3 0 0 1-4.591-3.666c-1.795-1.849-4.783-1.551-6.116.655l-.081.133c-9.331 15.295-27.592 21.168-40.786 13.118s-16.326-26.974-6.995-42.269",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#29493c",
    fillRule: "evenodd",
    d: "M273.779 325.447s13.586-6.98 34.248-.633c0 0-4.04 17.338-5.232 24.783l-32.287.207z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    fillRule: "evenodd",
    d: "m302.909 348.754-.117 3.762s-11.435 2.012-35.624 1.199l3.338-3.911s23.334.289 32.403-1.05",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    fillRule: "evenodd",
    d: "m286.512 306.599-1.574 15.585a2.47 2.47 0 0 0 1.903 2.656c2.778.639 7.8 1.391 12.016-.154a2.49 2.49 0 0 0 1.633-2.568l-1.543-16.009z",
    clipRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    fillRule: "evenodd",
    d: "M275.88 297.495c1.529 10.865 9.534 21.112 22.128 18.856 8.713-1.56 11.376-9.863 9.848-20.729s-9.206-19.128-17.972-17.895c-8.765 1.233-15.532 8.902-14.004 19.768",
    clipRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    fillRule: "evenodd",
    d: "M278.689 301.884s-1.96-6.13-4.585-3.43c-2.625 2.701 3.555 9.087 5.585 9.043 2.03-.043-1-5.613-1-5.613",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M273.857 297.037s9.658 11.011 15.394-11.175c0 0 4.979 6.8 7.481.963 0 0 10.164 3.778 11.408-.506s-13.451-16.365-25.726-8.282c-12.275 8.084-8.557 19-8.557 19",
    clipRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    fillRule: "evenodd",
    d: "M273.339 325.575s-19.335 14.628-8.406 32.706c8.406 13.906 27.898-1.349 27.898-1.349l-5.933-5.509s-6.356 6.639-11.441 2.472 2.119-16.455 2.119-16.455-.424-9.323-4.237-11.865",
    clipRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "m289.603 360.906 16.61.579a1.924 1.924 0 0 0 1.989-2.015l-.78-16.384a1.925 1.925 0 0 0-1.922-1.833h-15.83a1.925 1.925 0 0 0-1.924 1.924v15.806c0 1.037.821 1.887 1.857 1.923"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    fillRule: "evenodd",
    d: "M287.748 355.838s-3.297-1.646-2.709-5.361c.587-3.715 1.435-4.986 5.672-4.563 4.238.424 7.204 4.662 2.119 6.78s-5.082 3.144-5.082 3.144",
    clipRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    fillRule: "evenodd",
    d: "M308.208 356.932s1.997-3.814 1.15-7.204-4.661-4.661-8.051-5.509c-3.39-.847-2.876 3.118-.802 5.585s7.824 4.585 7.703 7.128",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 386.648,
    x2: 381.336,
    y1: 68.75,
    y2: 66.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 381.314,
    x2: 434.529,
    y1: 95.227,
    y2: 98.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 441.087,
    x2: 437.07,
    y1: 118.781,
    y2: 116.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 137.564,
    x2: 136.034,
    y1: 479.506,
    y2: 433.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 83.025,
    x2: 177.6,
    y1: 362.028,
    y2: 436.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 139.386,
    x2: 134.253,
    y1: 363.164,
    y2: 407.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 226.539,
    x2: 135.082,
    y1: 384.068,
    y2: 455.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 200.164,
    x2: 201.694,
    y1: 507.892,
    y2: 461.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 193.462,
    x2: 188.66,
    y1: 368.896,
    y2: 410.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 143.043,
    x2: 166.063,
    y1: 79.151,
    y2: 79.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 2073.5,
    x2: 2104.07,
    y1: -1698.24,
    y2: -1726.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 2069.45,
    x2: 2100.03,
    y1: -1702.69,
    y2: -1730.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 148.647,
    x2: 107.681,
    y1: 196.622,
    y2: 231.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 173.296,
    x2: 196.339,
    y1: 198.508,
    y2: 221.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 20.179,
    x2: 0,
    y1: 395.323,
    y2: 395.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 105.444,
    x2: 76.406,
    y1: 474.896,
    y2: 135.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 113.928,
    x2: 81.277,
    y1: 391.639,
    y2: 391.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 47.029,
    x2: 17.983,
    y1: 479.946,
    y2: 140.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 108.629,
    x2: 103.174,
    y1: 140.363,
    y2: 100.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 86.146,
    x2: 49.91,
    y1: 159.809,
    y2: 159.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 118.341,
    x2: 88.112,
    y1: 92.305,
    y2: -0.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 107.296,
    x2: 77.068,
    y1: 95.922,
    y2: 3.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 324.625,
    x2: 343.53,
    y1: 328.129,
    y2: 383.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 387.683,
    x2: 361.418,
    y1: 329.848,
    y2: 393.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 453.1,
    x2: 476.947,
    y1: 400.385,
    y2: 400.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 468.84,
    x2: 443.668,
    y1: 357.389,
    y2: 425.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 395.229,
    x2: 371.377,
    y1: 400.267,
    y2: 399.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 368.45,
    x2: 389.321,
    y1: 400.01,
    y2: 400.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 418.411,
    x2: 393.226,
    y1: 336.842,
    y2: 405.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 426.456,
    x2: 425.876,
    y1: 345.526,
    y2: 295.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 414.229,
    x2: 428.964,
    y1: 316.622,
    y2: 275.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 398.141,
    x2: 412.876,
    y1: 310.822,
    y2: 269.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 429.588,
    x2: 444.324,
    y1: 322.16,
    y2: 281.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 465.071,
    x2: 418.406,
    y1: 335.675,
    y2: 448.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 435.336,
    x2: 426.089,
    y1: 380.574,
    y2: 402.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 349.785,
    x2: 416.132,
    y1: 356.512,
    y2: 427.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 356.31,
    x2: 343.255,
    y1: 333.503,
    y2: 365.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 346.456,
    x2: 415.355,
    y1: 381.886,
    y2: 482.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 345.426,
    x2: 276.528,
    y1: 375.106,
    y2: 442.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cb236d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 257.494,
    x2: 279.225,
    y1: 374.352,
    y2: 398.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 248.818,
    x2: 243.899,
    y1: 410.718,
    y2: 391.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 251.304,
    x2: 300.257,
    y1: 387.024,
    y2: 423.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 243.434,
    x2: 251.09,
    y1: 358.761,
    y2: 296.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 316.069,
    x2: 308.361,
    y1: 326.551,
    y2: 360.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 292.072,
    x2: 278.388,
    y1: 305.767,
    y2: 397.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 299.937,
    x2: 290.865,
    y1: 345.703,
    y2: 310.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 95.374,
    x2: -22.041,
    y1: 213.718,
    y2: 169.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: -58.468,
    x2: -165.608,
    y1: 107.711,
    y2: 45.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 282.492,
    x2: 274.135,
    y1: 327.665,
    y2: 364.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 303.772,
    x2: 346.514,
    y1: 337.268,
    y2: 233.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdf53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d93c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 291.22,
    x2: 288.906,
    y1: 345.975,
    y2: 356.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 305.126,
    x2: 302.708,
    y1: 345.091,
    y2: 355.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyRoutine1);
export default __webpack_public_path__ + "static/media/Daily-Routine-1.afcc75b6d2d9845d6f55b27075589936.svg";
export { ForwardRef as ReactComponent };